export default "__VITE_ASSET__BNyCAH4V__"